import {useParams} from 'react-router-dom'

import {PathParamKey} from '../../definitions/routeTypes'
import {toInt} from '../../utils/fromParameterUtils'

export function useMaterialIdParameter(): number | undefined {
  return toInt(useParams<Pick<Record<PathParamKey, string>, 'materialId'>>().materialId)
}
